export default {
  setActivity (state, activity) {
    state.activity = activity
  },
  addNote (state, note) {
    state.activity.notes.push(note)
  },
  reset (state) {
    state.activity = {}
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/activity-notes/store/mutations.js